import React, { useContext, useEffect } from "react";
import { isDateFinalized, setDateHelper, userDetails } from "../../utils/Helper";
import ReactSelect from "react-select";
import DatePicker from "react-datepicker";
import calLogo from '../../assets/images/calender.svg'
import Button from "../../components/ui/Button";
import { useForm } from "react-hook-form";
import authContext from "../../context/authContext";
import useMakeRequest from "../../utils/ApiHelper";
import { ApiConstants } from "../../constants/ApiConstants";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from 'yup';
import ValidationMessage from "../../constants/ValidationMessage";
import { ErrorMessage } from "@hookform/error-message";
import moment from "moment";
import Select from "react-select";
import toast from "react-hot-toast";

interface choresFilterInputs {
    date?: string;
    d_by?: { value: string; label: string } | null;
    h_spent: string;
    m_date: string;
    new_date?: string;
    description?: string;
    status: { value: number; label: string } | null;
};

const EditChores = ({ doneByOptions, editChores, onSuccess, onCancel, finalizedMonths }: any) => {

    let profile: any = useContext(authContext);
    profile = profile?.data;
    const updateChores = useMakeRequest();

    const { register, watch, setValue, getValues, formState: { errors }, handleSubmit, trigger, reset } = useForm<choresFilterInputs>({
        mode: 'onChange',
        resolver: yupResolver(yup.object().shape({
            h_spent: yup
                .string()
                .test(
                    'h_spent-required',
                    ValidationMessage.Field("a value greater than 0"),
                    function (value: any) {
                        const { h_spent } = this.parent;
                        if (Number(h_spent) === 0) return false;
                        return true;
                    }
                )
        })) as any
    });

    const onSubmit = (payload: any) => {
        const is_finalized = isDateFinalized(payload?.new_date, finalizedMonths || []);
        if (is_finalized) {
            toast.error("Selected date already finalized.")
            return;
        }
        console.log("payload: ", payload)
        updateChores.makeRequest({
            url: ApiConstants?.ChoresUpdate,
            payload: {
                c_id: editChores?.uuid,
                is_modified: editChores?.is_modified,
                m_date: payload?.date,
                new_date: payload?.date === payload?.new_date ? null : payload?.new_date,
                d_by: payload?.d_by?.value,
                h_spent: payload?.h_spent,
                status: payload?.status?.value,
                description: payload?.description ?? ''
            }
        })
    }

    const getStatus = (status: number) => {
        return status == 1 ? 'Unassigned' : status == 2 ? 'Assigned' : status == 3 ? 'Completed' : ""
    }

    useEffect(() => {
        if (editChores && doneByOptions?.length > 0) {
            reset({
                date: editChores?.date,
                new_date: editChores?.date,
                h_spent: editChores?.hour_spent,
                m_date: editChores?.date,
                status: {
                    value: editChores?.status,
                    label: getStatus(editChores?.status)
                },
                description: editChores?.description ?? '',
                d_by: {
                    value: editChores?.done_by?.value,
                    label: profile?.uuid === editChores?.done_by?.value ? 'Me' : editChores?.done_by?.label
                }
            });
            trigger('h_spent');
        }
    }, [editChores, doneByOptions])

    useEffect(() => {
        if (updateChores?.status) {
            onSuccess()
            toast.success("Chore updated successfully.")
            $('.btn-close-modal').click();
        }
    }, [updateChores?.status])

    return (
        <div className="modal fade bottom-sheet-modal" id="choresUpdateModal" tabIndex={-1} aria-labelledby="choresUpdateModalLabel" aria-hidden="true" data-bs-backdrop="true" data-bs-keyboard="true">
            <div className="modal-dialog">
                <div className="modal-content">
                    {/* Bottom Sheet Handle */}
                    <div className="bottom-sheet-handle">
                        <div className="handle-bar"></div>
                    </div>

                    <div className="modal-header">
                        <h1 className="modal-title" id="choresUpdateModalLabel">Edit Chore</h1>
                    </div>

                    <div className="modal-body">
                        <form className="row gy-3" onSubmit={handleSubmit(onSubmit)}>
                            <div className='col-6'>
                                <div className="com-input-grp">
                                    <label className="form-label d-block">Date</label>
                                    <DatePicker
                                        className='form-control'
                                        placeholderText="MM/DD/YYYY"
                                        timeFormat="MM DD YYYY"
                                        onKeyDown={(e: any) => e.preventDefault()}
                                        showYearDropdown
                                        scrollableYearDropdown
                                        yearDropdownItemNumber={50}
                                        selected={watch('new_date') ? moment(watch('new_date')).toDate() : null}
                                        showIcon
                                        icon={<><img className="calIcon" src={calLogo} alt="" /></>}
                                        onChange={(start_date: any) => {
                                            setValue('new_date', setDateHelper({ date: start_date }))
                                            trigger('new_date')
                                        }}
                                    />
                                    <ErrorMessage
                                        errors={errors}
                                        name="s_date"
                                        render={({ message }) => <p className='valid-error'>{message}</p>}
                                    />
                                </div>
                            </div>

                            <div className="col-6">
                                <div className="com-input-grp">
                                    <label className="form-label">Hours</label>
                                    <div className='custom-select'>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder='Hours spent'
                                            max={24}
                                            min={0}
                                            value={watch('h_spent')}
                                            onInput={(e: any) => {
                                                let value = e.target.value.replace(/[^0-9.]/g, '');
                                                if (value === '') {
                                                    setValue('h_spent', '');
                                                    trigger('h_spent');
                                                    return;
                                                }
                                                const [hours, minutes] = value.split('.');
                                                if (parseInt(hours) > 24) {
                                                    value = '24';
                                                }
                                                if (minutes) {
                                                    if (minutes.length > 2) {
                                                        value = `${hours}.${minutes.substring(0, 2)}`;
                                                    }
                                                    if (parseInt(minutes[0]) > 5) {
                                                        value = `${hours}.5`;
                                                    } else if (minutes.length === 2 && parseInt(minutes) > 59) {
                                                        value = `${hours}.59`;
                                                    }
                                                }
                                                e.target.value = value;
                                                setValue('h_spent', value);
                                                trigger('h_spent');
                                            }}
                                        />
                                        <ErrorMessage
                                            errors={errors}
                                            name="h_spent"
                                            render={({ message }) => <p className='valid-error'>{message}</p>}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="col-6">
                                <div className="com-input-grp">
                                    <label className="form-label d-block">Status</label>
                                    <div className="custom-select">
                                        <Select
                                            value={watch('status')}
                                            options={[{ value: 1, label: "Unassigned" }, { value: 2, label: "Assigned" }, { value: 3, label: "Completed" }]}
                                            className="com-r-select"
                                            classNamePrefix="com-r-select"
                                            placeholder="Select"
                                            onChange={(selectedOption: any) => {
                                                setValue("status", selectedOption);
                                                trigger("d_by");
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>

                            {watch('status')?.value !== 1 && (
                                <div className="col-6">
                                    <div className="com-input-grp">
                                        <label className="form-label d-block">Member</label>
                                        <div className="custom-select">
                                            <ReactSelect
                                                options={doneByOptions}
                                                value={watch('d_by')}
                                                className="com-r-select"
                                                classNamePrefix="com-r-select"
                                                placeholder="Member"
                                                onChange={(selectedOption: any) => {
                                                    setValue("d_by", selectedOption);
                                                    trigger("d_by");
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            )}



                            <div className="col-12">
                                <div className="com-input-grp">
                                    <label className="form-label">Description</label>
                                    <div className='custom-select'>
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder='Type here'
                                            value={watch('description')}
                                            onInput={(e: any) => {
                                                let value = e.target.value
                                                if (value === '') {
                                                    setValue('description', '');
                                                    trigger('description');
                                                    return;
                                                }
                                                setValue('description', value);
                                                trigger('description');
                                            }}
                                        />
                                        <ErrorMessage
                                            errors={errors}
                                            name="description"
                                            render={({ message }) => <p className='valid-error'>{message}</p>}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className='d-flex gap-3'>
                                <button
                                    className='custom-grayed-btn modal-light-btn btn-close-modal'
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                    disabled={updateChores?.loading}
                                    type="button"
                                    onClick={onCancel}
                                    style={{ width: "50%" }}
                                >
                                    Cancel
                                </button>
                                <Button
                                    className='com-btn'
                                    type="submit"
                                    text="submit"
                                    style={{ width: "50%" }}
                                    loading={updateChores?.loading}
                                >
                                    Save
                                </Button>
                            </div>
                        </form>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default EditChores

// import React, { useContext, useEffect } from "react";
// import { isDateFinalized, setDateHelper, userDetails } from "../../utils/Helper";
// import ReactSelect from "react-select";
// import DatePicker from "react-datepicker";
// import calLogo from '../../assets/images/calender.svg'
// import Button from "../../components/ui/Button";
// import { useForm } from "react-hook-form";
// import authContext from "../../context/authContext";
// import useMakeRequest from "../../utils/ApiHelper";
// import { ApiConstants } from "../../constants/ApiConstants";
// import { yupResolver } from "@hookform/resolvers/yup";
// import * as yup from 'yup';
// import ValidationMessage from "../../constants/ValidationMessage";
// import { ErrorMessage } from "@hookform/error-message";
// import moment from "moment";
// import Select from "react-select";
// import toast from "react-hot-toast";

// interface choresFilterInputs {
//     date?: string;
//     d_by?: { value: string; label: string } | null; // Done by id
//     h_spent: string; // Hour spent
//     m_date: string;
//     new_date?: string;
//     description?: string;
//     status: { value: number; label: string } | null;
// };

// const EditChores = ({ doneByOptions, expensesCategories, editChores, onSuccess, onCancel, finalizedMonths }: any) => {

//     let profile: any = useContext(authContext);
//     profile = profile?.data;
//     const updateChores = useMakeRequest();


//     const { register, watch, setValue, getValues, formState: { errors }, handleSubmit, trigger, reset } = useForm<choresFilterInputs>({
//         mode: 'onChange',
//         resolver: yupResolver(yup.object().shape({
//             h_spent: yup
//                 .string()
//                 .test(
//                     'h_spent-required',
//                     ValidationMessage.Field("a value greater than 0"),
//                     function (value: any) {
//                         const { h_spent } = this.parent;
//                         if (Number(h_spent) === 0) return false;
//                         return true;
//                     }
//                 )
//         })) as any
//     });

//     const onSubmit = (payload: any) => {

//         const is_finalized = isDateFinalized(payload?.new_date, finalizedMonths || []);
//         if (is_finalized) {
//             toast.error("Selected date already finalized.")
//             return;
//         }
//         console.log("payload: ", payload)
//         updateChores.makeRequest({
//             url: ApiConstants?.ChoresUpdate,
//             payload: {
//                 c_id: editChores?.uuid,
//                 is_modified: editChores?.is_modified,
//                 m_date: payload?.date,
//                 new_date: payload?.date === payload?.new_date ? null : payload?.new_date,
//                 d_by: payload?.d_by?.value,
//                 h_spent: payload?.h_spent,
//                 status: payload?.status?.value,
//                 description: payload?.description
//             }
//         })

//     }
//     const getStatus = (status: number) => {
//         return status == 1 ? 'Unassigned' : status == 2 ? 'Assigned' : status == 3 ? 'Completed' : ""
//     }


//     useEffect(() => {
//         if (editChores && doneByOptions?.length > 0) {
//             setValue('date', editChores?.date)
//             setValue('new_date', editChores?.date)
//             setValue('h_spent', editChores?.hour_spent)
//             setValue('m_date', editChores?.date)
//             setValue('status', {
//                 value: editChores?.status,
//                 label: getStatus(editChores?.status)
//             })
//             setValue('description', editChores?.description)
//             setValue('d_by', {
//                 value: editChores?.done_by?.value,
//                 label: profile?.uuid === editChores?.done_by?.value ? 'Me' : editChores?.done_by?.label
//             })


//             trigger('h_spent')
//         }
//     }, [editChores, doneByOptions, expensesCategories])

//     useEffect(() => {
//         if (updateChores?.status) {
//             onSuccess()
//             toast.success("Chore updated successfully.")
//             $('.btn-close-modal').click();
//         }
//     }, [updateChores?.status])


//     return (
//         <div className="modal fade inner-modal com-modal" id="choresUpdateModal" tabIndex={-1} aria-labelledby="choresUpdateModalLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false" >
//             <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable" >
//                 <div className="modal-content">
//                     <div className="modal-header">
//                         <h1 className="modal-title" id="choresUpdateModalLabel">Edit Chore</h1>
//                     </div>
//                     <div className="modal-body">
//                         <form className="row gy-3" onSubmit={handleSubmit(onSubmit)}>
//                             <div className='col-12'>
//                                 <div className="com-input-grp">
//                                     <label className="form-label d-block">Select Date</label>
//                                     <DatePicker
//                                         className='form-control'
//                                         placeholderText="MM/DD/YYYY"
//                                         timeFormat="MM DD YYYY"
//                                         onKeyDown={(e: any) => e.preventDefault()}
//                                         showYearDropdown
//                                         scrollableYearDropdown
//                                         yearDropdownItemNumber={50}
//                                         // selected={watch("s_date") as any}
//                                         selected={watch('new_date') ? moment(watch('new_date')).toDate() : null}
//                                         showIcon
//                                         icon={<><img className="calIcon" src={calLogo} alt="" /></>}
//                                         onChange={(start_date: any) => {
//                                             setValue('new_date', setDateHelper({ date: start_date }))
//                                             trigger('new_date')
//                                         }}
//                                     // minDate={moment(profile?.hh_member?.billing_date).toDate()}
//                                     />

//                                     <ErrorMessage
//                                         errors={errors}
//                                         name="s_date"
//                                         render={({ message }) => <p className='valid-error'>{message}</p>}
//                                     />
//                                 </div>
//                             </div>

//                             <div className="col-6">
//                                 <div className="com-input-grp">
//                                     <label className="form-label d-block">Status</label>
//                                     <div className="custom-select">
//                                         <Select
//                                             value={watch('status')}
//                                             options={[{ value: 1, label: "Unassigned" }, { value: 2, label: "Assigned" }, { value: 3, label: "Completed" },]}
//                                             className="com-r-select"
//                                             classNamePrefix="com-r-select"
//                                             placeholder="Select"
//                                             onChange={(selectedOption: any) => {
//                                                 setValue("status", selectedOption);
//                                                 trigger("d_by");
//                                             }}
//                                         />
//                                     </div>
//                                 </div>
//                             </div>
//                             {watch('status')?.value !== 1 && (
//                                 <div className="col-6">
//                                     <div className="com-input-grp">
//                                         <label className="form-label d-block">Member</label>
//                                         <div className="custom-select">
//                                             <ReactSelect
//                                                 options={doneByOptions}
//                                                 value={watch('d_by')}
//                                                 className="com-r-select"
//                                                 classNamePrefix="com-r-select"
//                                                 placeholder="Member"
//                                                 isLoading={expensesCategories?.loading}
//                                                 onChange={(selectedOption: any) => {
//                                                     setValue("d_by", selectedOption);
//                                                     trigger("d_by");
//                                                 }}
//                                             />
//                                         </div>
//                                     </div>
//                                 </div>
//                             )}
//                             <div className="col-12">
//                                 <div className="com-input-grp">
//                                     <label className="form-label">Hours</label>
//                                     <div className='custom-select'>
//                                         <input type="text" className="form-control" placeholder='Hours spent' max={24} min={0} value={watch('h_spent')}
//                                             onInput={(e: any) => {
//                                                 let value = e.target.value.replace(/[^0-9.]/g, '');
//                                                 if (value === '') {
//                                                     setValue('h_spent', '');
//                                                     trigger('h_spent');
//                                                     return;
//                                                 }
//                                                 const [hours, minutes] = value.split('.');
//                                                 if (parseInt(hours) > 24) {
//                                                     value = '24';
//                                                 }
//                                                 if (minutes) {
//                                                     if (minutes.length > 2) {
//                                                         value = `${hours}.${minutes.substring(0, 2)}`;
//                                                     }
//                                                     if (parseInt(minutes[0]) > 5) {
//                                                         value = `${hours}.5`;
//                                                     } else if (minutes.length === 2 && parseInt(minutes) > 59) {
//                                                         value = `${hours}.59`;
//                                                     }
//                                                 }
//                                                 e.target.value = value;
//                                                 setValue('h_spent', value);
//                                                 trigger('h_spent');
//                                             }}
//                                         />
//                                         <ErrorMessage
//                                             errors={errors}
//                                             name="h_spent"
//                                             render={({ message }) => <p className='valid-error'>{message}</p>}
//                                         />
//                                     </div>
//                                 </div>
//                             </div>
//                             <div className="col-12">
//                                 <div className="com-input-grp">
//                                     <label className="form-label">Description</label>
//                                     <div className='custom-select'>
//                                         <input type="text" className="form-control" placeholder='Type here' max={24} min={0} value={watch('description')}
//                                             onInput={(e: any) => {
//                                                 let value = e.target.value
//                                                 if (value === '') {
//                                                     setValue('description', '');
//                                                     trigger('description');
//                                                     return;
//                                                 }
//                                                 setValue('description', value);
//                                                 trigger('description');
//                                             }}
//                                         />
//                                         <ErrorMessage
//                                             errors={errors}
//                                             name="description"
//                                             render={({ message }) => <p className='valid-error'>{message}</p>}
//                                         />
//                                     </div>
//                                 </div>
//                             </div>
//                             {/* <div className="col-12">
//                                 <div className="com-input-grp">
//                                     <label className="form-label">Done By</label>
//                                     <div className='custom-select'>
//                                         <ReactSelect
//                                             options={doneByOptions}
//                                             value={watch('d_by')}
//                                             className="com-r-select"
//                                             classNamePrefix="com-r-select"
//                                             placeholder="Expense Type"
//                                             isLoading={expensesCategories?.loading}
//                                             onChange={(selectedOption: any) => {
//                                                 setValue("d_by", selectedOption);
//                                                 trigger("d_by");
//                                             }}
//                                         />
//                                     </div>
//                                 </div>
//                             </div> */}
//                             <div className='page-padding-x pb-4 d-flex'>
//                                 <Button className='com-btn mt-2 me-4' style={{ width: "50%" }} type="submit" text="submit" loading={updateChores?.loading}>Save</Button>
//                                 <button className='com-btn com-btn-outline mt-2  btn-close-modal' style={{ width: "50%" }} data-bs-dismiss="modal" aria-label="Close" disabled={updateChores?.loading} type="button" onClick={onCancel}>Cancel</button>
//                             </div>
//                         </form>

//                     </div>
//                 </div>
//             </div>
//         </div>
//     )
// }

// export default EditChores